import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
type Bonus = {
  number: string;
  title: string;
  description: string;
  /** Precio de referencia mostrado tachado. TODO: definir valores reales. */
  value: string;
  cover: string;
  coverAlt: string;
};
const BONUSES: Bonus[] = [{
  number: 'BONO 01',
  title: 'Guía Express de Configuración Perfecta para iPhone',
  description: 'Paso a paso por los ajustes más importantes para dejar tu iPhone listo desde el primer día: pantalla, notificaciones, privacidad, batería, Face ID, iCloud y organización inicial. Una victoria rápida que notarás en los primeros 30 minutos.',
  cover: 'https://cdn.magicpatterns.com/uploads/tFyk6LhnQsCCUg82Qs21Vt/apple_1.webp',
  coverAlt: 'Portada del bono Configuración Perfecta para iPhone',
  value: '[completar]'
}, {
  number: 'BONO 02',
  title: 'Checklist de Seguridad y Privacidad',
  description: 'Punto por punto qué revisar para proteger tu información: bloqueo de pantalla, Face ID, permisos de apps, ubicación, contraseñas, copias de seguridad y protección ante pérdida o robo. Más tranquilidad en menos de una hora.',
  cover: 'https://cdn.magicpatterns.com/uploads/hCx4Fe5yzFPSCrrvodYKhR/apple_2.webp',
  coverAlt: 'Portada del bono Privacidad para Proteger tu iPhone',
  value: '[completar]'
}, {
  number: 'BONO 03',
  title: 'Mini Guía de Trucos Ocultos para Ahorrar Tiempo',
  description: 'Atajos de teclado, gestos, búsqueda ultrarrápida, escaneo de documentos, copiar texto desde fotos y comandos que casi nadie usa. Trucos que puedes probar hoy mismo en menos de 5 minutos.',
  cover: 'https://cdn.magicpatterns.com/uploads/hUs9cqSZvvFDfUkrAxnQU2/apple_3.webp',
  coverAlt: 'Portada del bono Trucos Ocultos para Ahorrar Tiempo con tu iPhone',
  value: '[completar]'
}, {
  number: 'BONO 04',
  title: 'Plantilla de Organización Digital para iPhone',
  description: 'Una estructura lista para ordenar todo: apps por categorías, pantallas limpias, fotos ordenadas, notas organizadas y una rutina simple de mantenimiento semanal. Menos caos, más orden, más control.',
  cover: 'https://cdn.magicpatterns.com/uploads/tyNpRzvyEsZjg4cJTZvWgg/apple_5.webp',
  coverAlt: 'Portada del bono Plantilla de Organización Digital para iPhone',
  value: '[completar]'
}, {
  number: 'BONO 05',
  title: 'Manual Rápido de Cámara iPhone',
  description: 'Trucos simples de iluminación, enfoque, exposición, composición y edición básica para que tus fotos y videos se vean mucho mejor desde hoy. Resultados visibles desde la primera foto.',
  cover: 'https://cdn.magicpatterns.com/uploads/fjXCHKhDju8RZRgAqyMiuZ/apple_6.webp',
  coverAlt: 'Portada del bono Manual Rápido de Cámara iPhone para fotos y videos',
  value: '[completar]'
}];
export function Bonuses() {
  return <Section className="bg-cream-50" data-id="element-64" data-mp="2a4pjxfl9ak6i">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-gold-deep" data-id="element-65" data-mp="2a3o1ur5toxfa">
        Incluidos hoy sin costo extra
      </p>
      <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-ink-950 sm:text-4xl" data-id="element-66" data-mp="27jzuxibp3p7p">
        Cinco bonos estratégicos
      </h2>
      <p className="mt-4 text-base text-ink-800/75 sm:text-lg" data-id="element-67" data-mp="22lydt2xtxzyv">
        Cinco materiales adicionales que se suman al libro principal, hoy
        completamente gratis.
      </p>

      <div className="mt-10 grid gap-3 md:grid-cols-2" data-id="element-68" data-mp="1tkrtsjvz270v">
        {BONUSES.map(bonus => <article key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-3xl border border-ink-950/10 bg-white" data-id="element-69" data-mp="1ol5fs88bkmr0">
            <img src={bonus.cover} alt={bonus.coverAlt} className="aspect-[4/3] w-full object-cover" data-id="element-70" data-mp="1jtdykob1ztdj" />
            <div className="flex flex-1 flex-col p-6" data-id="element-71" data-mp="1ewdrca2gwkku">
              <div className="flex items-center justify-between gap-3" data-id="element-72" data-mp="19w9bmm9dvtvo">
                <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-ink-950/45" data-id="element-73" data-mp="19y2fjtsm3zzz">
                  {bonus.number}
                </span>
                <span className="flex items-center gap-2" data-id="element-74" data-mp="10vb4vw7k989e">
                  <span className="text-[11px] font-semibold text-ink-950/35 line-through" data-id="element-75" data-mp="10xxctwyd5ps5">
                    {bonus.value}
                  </span>
                  <span className="rounded-full border border-gold/40 bg-gold/15 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-gold-deep" data-id="element-76" data-mp="34ycrmn2ktxtd">
                    Gratis hoy
                  </span>
                </span>
              </div>
              <h3 className="mt-4 text-lg font-bold leading-snug text-ink-950" data-id="element-77" data-mp="2h9tg7yo8d4x2">
                {bonus.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-800/75" data-id="element-78" data-mp="2m96edfkjxyey">
                {bonus.description}
              </p>
            </div>
          </article>)}
      </div>

      <div className="mt-10" data-id="element-79" data-mp="2d884whrcgyoz">
        <CTAButton className="items-center" note="Los 5 bonos se suman al libro principal, sin costo extra." data-id="element-80" data-mp="2d99juxbhe5bz" />
      </div>
    </Section>;
}